<template>
  <v-dialog
      scrollable
      v-model="visible"
      max-width="350px"
      :persistent="true"
  >
    <v-card>
      <v-card-title class="subheading">
        {{ loading ? '正在下载…' : '下载完成' }}
      </v-card-title>

      <v-divider></v-divider>

      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <p class="subheading">{{ message }}</p>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn flat color="primary" @click.native="visible = false">取消</v-btn>
        <v-btn color="primary" :disabled="loading" @click.native="onDelete">确认</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ['value', 'message', 'url'],

  data() {
    return {
      loading: false
    }
  },

  computed: {
    visible: {
      // getter
      get: function () {
        return this.value;
      },
      // setter
      set: function (nv) {
        this.$emit('input', nv);
      }
    }
  },

  watch: {
    value(newVal, oldVal) {
      if (newVal && this.$props.url) {
        this.download()
      }
    }
  },

  methods: {
    getFilename(response) {
      if (!response.headers['content-disposition']) return null;

      const contentDisposition = response.headers['content-disposition'];

      // 匹配 filename 和 filename*（优先）
      const matches = contentDisposition.match(
          /filename\*?=(["']?)(.*?)\1(;|$)/gi
      ) || [];

      let filename = "";

      // 优先从 filename* 解析 UTF-8 编码的文件名
      for (const match of matches) {
        if (match.includes("filename*")) {
          // 处理 RFC 5987 编码格式：filename*=UTF-8''%E4%B8%AD%E6%96%87.txt
          const encoded = match.split("'").pop(); // 提取编码后的部分（如 "%E4%B8%AD%E6%96%87.txt"）
          filename = decodeURIComponent(encoded);
          break;
        } else if (match.includes("filename=")) {
          // 处理普通格式：filename="%E4%B8%AD%E6%96%87.txt" 或 filename="中文.txt"
          const value = match.split("=")[1].trim();
          filename = value.replace(/['"]/g, ''); // 去除引号
          // 尝试解码百分号编码（如果存在）
          try {
            filename = decodeURIComponent(filename);
          } catch {
            // 非编码内容保持原样
          }
        }
      }

      return filename || null;
    },

    download() {
      const vm = this;
      this.loading = true;

      this.$http({
        method: 'get',
        url: this.$props.url,
        responseType: 'blob'
      }).then(response => {

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        const filename = this.getFilename(response) || 'filename.pdf'
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();

        vm.$emit('ok');
        vm.loading = false;
        this.visible = false;
      });
    }
  }
}
</script>
<style scoped>
div.card div.card__text {
  display: flex;
  font-size: 14px;
  margin: 4px auto;
  padding: 8px 15px;
  position: relative;
}

div.card div.card__text > div {
  -ms-flex-item-align: center;
  align-self: center;
  -webkit-box-flex: 1;
  -ms-flex: 1 1;
  flex: 1 1;
  margin-left: 1em;
}
</style>
